module.exports = __webpack_public_path__ + "static/media/promo3-background-mob.0089c559.svg";